// Placeholder decoder for EEG packets coming from Bun WebSocket.
// The real implementation should mirror your backend's decode logic
// and extract qCON, qNOX, SQI, EMG, etc. for display.

/**
 * Decode a message from the EEG WebSocket stream.
 * @param {{ type: string, data: any }} msg - Raw message from the WebSocket.
 * @returns {{
 *   timestamp: number | null,
 *   qCON: number | null,
 *   qNOX: number | null,
 *   SQI: number | null,
 *   EMG: number | null,
 *   BSR: number | null,
 *   state: number | null,
 *   eegSamples: number[] | null,
 * }} A simplified, frontend-friendly structure.
 */
export function decodeEegMessage(msg) {
  if (!msg || !msg.data) {
    return {
      timestamp: null,
      qCON: null,
      qNOX: null,
      SQI: null,
      EMG: null,
      BSR: null,
      state: null,
      eegSamples: null,
    };
  }

  const data = msg.data;

  // Extract values from the new decoder output structure
  // The backend now sends eeg_samples_uv (scaled to µV, clamped to ±120 µV)
  return {
    timestamp: typeof data.timestamp === "number" ? data.timestamp : null,
    qCON: typeof data.qCON === "number" ? data.qCON : null,
    qNOX: typeof data.qNOX === "number" ? data.qNOX : null,
    SQI: typeof data.SQI === "number" ? data.SQI : null,
    EMG: typeof data.EMG === "number" ? data.EMG : null,
    BSR: typeof data.BSR === "number" ? data.BSR : null,
    state: typeof data.state === "number" ? data.state : null,
    // Use eeg_samples_uv from the new decoder (already in µV, clamped to ±120 µV)
    eegSamples: Array.isArray(data.eeg_samples_uv) ? data.eeg_samples_uv : null,
  };
}



